export default __webpack_public_path__ + "static/media/sample-insurance-card.e2dcd97e.svg";